import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantBillingAccount = {
  namespaced: true,

  state: () => ({
    allMerchantsBillingAccounts: [],
    merchantBillingAccounts: [],
    merchantAuthorizerBillingAccounts: [],
    merchantAuthorizerGroupBillingAccounts: [],
    pendingMerchantBillingAccounts: [],
    resubmittedMerchantBillingAccounts: [],
    approvedMerchantBillingAccounts: [],
    approvedMerchantBillingAccountsByMerchantId: [],
    disapprovedMerchantBillingAccounts: [],
    activatedMerchantBillingAccounts: [],
    deactivatedMerchantBillingAccounts: []
  }),

  getters: {
    _allMerchantsBillingAccounts: state => state.allMerchantsBillingAccounts,
    _merchantBillingAccounts: state => state.merchantBillingAccounts,
    _merchantAuthorizerBillingAccounts: state => state.merchantAuthorizerBillingAccounts,
    _merchantAuthorizerGroupBillingAccounts: state => state.merchantAuthorizerGroupBillingAccounts,
    _pendingMerchantBillingAccounts: state => state.pendingMerchantBillingAccounts,
    _resubmittedMerchantBillingAccounts: state => state.resubmittedMerchantBillingAccounts,
    _approvedMerchantBillingAccounts: state => state.approvedMerchantBillingAccounts,
    _approvedMerchantBillingAccountsByMerchantId: state => state.approvedMerchantBillingAccountsByMerchantId,
    _disapprovedMerchantBillingAccounts: state => state.disapprovedMerchantBillingAccounts,
    _activatedMerchantBillingAccounts: state => state.activatedMerchantBillingAccounts,
    _deactivatedMerchantBillingAccounts: state => state.deactivatedMerchantBillingAccounts
  },

  mutations: {
    ALL_MERCHANTS_BILLING_ACCOUNTS (state, data) {
      state.allMerchantsBillingAccounts = data
    },
    MERCHANT_AUTHORIZER_BILLING_ACCOUNTS (state, data) {
      state.merchantAuthorizerBillingAccounts = data
    },
    MERCHANT_AUTHORIZER_GROUP_BILLING_ACCOUNTS (state, data) {
      state.merchantAuthorizerGroupBillingAccounts = data
    },
    MERCHANT_BILLING_ACCOUNTS (state, data) {
      state.merchantBillingAccounts = data
    },
    PENDING_MERCHANT_ACCOUNTS (state, data) {
      state.pendingMerchantBillingAccounts = data
    },
    RESUBMITTED_MERCHANT_ACCOUNTS (state, data) {
      state.resubmittedMerchantBillingAccounts = data
    },
    APPROVED_MERCHANT_ACCOUNTS (state, data) {
      state.approvedMerchantBillingAccounts = data
    },
    APPROVED_MERCHANT_BILLING_ACCOUNTS_BY_MERCHANT_ID (state, data) {
      state.approvedMerchantBillingAccountsByMerchantId = data
    },
    DISAPPROVED_MERCHANT_ACCOUNTS (state, data) {
      state.disapprovedMerchantBillingAccounts = data
    },
    ACTIVATED_MERCHANT_ACCOUNTS (state, data) {
      state.activatedMerchantBillingAccounts = data
    },
    DEACTIVATED_MERCHANT_ACCOUNTS (state, data) {
      state.deactivatedMerchantBillingAccounts = data
    }
  },

  actions: {
    CreateMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBillingAccount/CreateMerchantBillingAccount', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBillingAccount/UpdateMerchantBillingAccount', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              // rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    CreateMerchantTransactionAuthorizerGroupBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantBillingAccount/CreateMerchantTransactionAuthorizerGroupBillingAccount', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantTransactionAuthorizerGroupBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post(`/MerchantBillingAccount/DeleteMerchantTransactionAuthorizerGroupBillingAccount?MerchantTransactionAuthorizerGroupBillingAccountId=${data.merchantTransactionAuthorizerGroupBillingAccountId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    UpdateMandateReference ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantBillingAccount/UpdateMandateReference?MerchantBilligAccountId=${data.merchantBilligAccountId}&NIBBSMandateReferenceNo=${data.mandateReferenceNo}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantBillingAccount/ApproveMerchantBillingAccount?MerchantBilligAccountId=${data.MerchantBilligAccountId}&Comment=${data.Comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantBillingAccount/DisapproveMerchantBillingAccount?MerchantBilligAccountId=${data.MerchantBilligAccountId}&Comment=${data.Comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ActivateMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantBillingAccount/ActivateMerchantBilligAccount?MerchantBilligAccountId=${data.MerchantBilligAccountId}&Comment=${data.Comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeactivateMerchantBillingAccount ({ rootState, dispatch }, { headers, data }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/MerchantBillingAccount/DeactivateMerchantBilligAccount?MerchantBilligAccountId=${data.MerchantBilligAccountId}&Comment=${data.Comment}`, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            // rootState.loading = false
            resolve(data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantBillingAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllMerchantBillingAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantBillingAccountsByAuthorizer ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetMerchantBillingAccountsByAuthorizer', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetMerchantBillingAccountsByAuthorizerGroup ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBillingAccount/GetMerchantBillingAccountsByAuthorizerGroup?MerchantTransactionAuthorizerGroupId=${payload.merchantAuthorizerGroupId}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantAccountByMerchantId ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBillingAccount/GetMerchantAccountByMerchantId?MerchantId=${payload.id}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantAccountById ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBillingAccount/GetMerchantAccountById?MerchantBillingAccountId=${payload.id}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetPendingMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetPendingMerchantAccountsApproval', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllResubmittedMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllResubmittedMerchantAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllApprovedMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllApprovedMerchantAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllApprovedMerchantAccountsByMerchantId ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantBillingAccount/GetAllApprovedMerchantAccountsByMerchantId?MerchantId=${payload.id}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllDisapprovedMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllDisapprovedMerchantAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllActivatedMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllActivatedBillingMerchantAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllDeactivatedMerchantAccounts ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantBillingAccount/GetAllDeactivatedMerchantBillingAccounts', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    DownloadBillingAccountMandate ({ rootState, dispatch }, { merchantBillingAccountId, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api({
          url: `/MerchantBillingAccount/DownloadBillingAccountMandate?MerchantBilligAccountId=${merchantBillingAccountId}`,
          method: 'GET',
          responseType: 'blob', // file type to be returned
          headers: config.headers
        })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantBillingAccount
